import { create } from 'zustand'
import type { Opener } from '@/components/helpFeedback/conversation'

/**
 * How code above the Help & feedback host reaches it (SA-1306 spec §2.4): the toasts sit outside the
 * host in the tree, so they cannot call `useHelpFeedback()`. The host says it is mounted and offered
 * (`hostReady`) and opens any `pendingOpen` a caller asked for. Mount state, not identity: kept across
 * identity changes (`identityScope.KEPT`), and the request is consumed the moment it is made.
 */
interface HelpFeedbackBridge {
  hostReady: boolean
  pendingOpen: Opener | null
  setHostReady: (ready: boolean) => void
  requestOpen: (opener: Opener) => void
  consumePendingOpen: () => Opener | null
}

export const useHelpFeedbackBridge = create<HelpFeedbackBridge>((set, get) => ({
  hostReady: false,
  pendingOpen: null,
  setHostReady: (hostReady) => set({ hostReady }),
  requestOpen: (pendingOpen) => set({ pendingOpen }),
  consumePendingOpen: () => {
    const opener = get().pendingOpen
    if (opener) set({ pendingOpen: null })
    return opener
  },
}))
